import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-public',
  templateUrl: './public.component.html',
  styleUrls: ['./public.component.scss'],
})
export class AppLayoutPublicComponent {}
